var map = {
	"./blocks/custom/accordion/block.js": "./resources/components/canvas/blocks/custom/accordion/block.js",
	"./blocks/custom/blogSlider/block.js": "./resources/components/canvas/blocks/custom/blogSlider/block.js",
	"./blocks/custom/pageSlider/block.js": "./resources/components/canvas/blocks/custom/pageSlider/block.js",
	"./blocks/custom/portfolioSlider/block.js": "./resources/components/canvas/blocks/custom/portfolioSlider/block.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/components/canvas sync recursive ^((?%21admin).)*\\/block.(js%7Cvue)$";